// eslint-disable-next-line no-shadow
export enum SlidePermissions {
  EDIT_SLIDE = 'admin.coursebuilder.slideeditor.edit',
  ADD_SLIDE_NOTES = 'admin.coursebuilder.slidenotes.add',
}
